import React, { useEffect, useMemo, useRef, useState } from 'react';

import { signOut, User } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { BsFilePersonFill } from 'react-icons/bs';
import { FaCircle, FaExclamationCircle } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';

import UserReputation from 'interfaces/UserReputation';
import { auth, db } from 'services/firebase';
import { COLORS } from 'styles/constants';
import calcUserPoints from 'utils/calcUserPoints';

import {
  Container,
  ProfileContainer,
  ProfileInfo,
  MenuItem,
  ReputationDisplay,
  PointDisplay,
  NotVerifiedDisplay,
  SignOutButton,
} from './styles';

interface DropDownMenuProps {
  user: User;
  userVerified: boolean;
  isOpen: boolean;
  closeDropDown: () => void;
}

const DropDownMenu: React.FC<DropDownMenuProps> = ({
  user,
  userVerified,
  isOpen,
  closeDropDown,
}) => {
  const history = useHistory();
  const containerRef = useRef<HTMLUListElement>(null);

  const [userReputation, setUserReputation] = useState<UserReputation>();

  const userPoints = useMemo(() => {
    return calcUserPoints(userReputation?.achievements);
  }, [userReputation]);

  useEffect(() => {
    const loadUserReputation = async (): Promise<void> => {
      const userReputationRef = doc(db, 'reputation', user.uid);
      const userReputationSnap = await getDoc(userReputationRef);
      setUserReputation(userReputationSnap.data() as UserReputation);
    };

    loadUserReputation();
  }, [user.uid]);

  return (
    <Container
      ref={containerRef}
      tabIndex={0}
      isOpen={isOpen}
      onBlur={closeDropDown}
    >
      <ProfileContainer
        onClick={closeDropDown}
        to={(location) => ({ ...location, pathname: `/profile/${user.uid}` })}
      >
        {user.photoURL ? (
          <img src={user.photoURL} alt="Perfil do usuário" />
        ) : (
          <BsFilePersonFill />
        )}
        <div style={{ width: 20 }} />
        <ProfileInfo>
          <h3>{user.displayName}</h3>
          <ReputationDisplay>
            {userVerified ? (
              <PointDisplay>
                <FaCircle color={COLORS.primary} />
                <div style={{ width: 7 }} />
                {userPoints && <p>{userPoints} pontos</p>}
              </PointDisplay>
            ) : (
              <NotVerifiedDisplay>
                <FaExclamationCircle color="red" size={25} />
                <div style={{ width: 10 }} />
                <span>Usuário não verificado</span>
              </NotVerifiedDisplay>
            )}
          </ReputationDisplay>
        </ProfileInfo>
      </ProfileContainer>
      <MenuItem
        to={{ pathname: `https://2rht68app8p.typeform.com/circle-indique` }}
        target="_blank"
      >
        Indicar um serviço
      </MenuItem>
      <SignOutButton
        type="button"
        onClick={async () => {
          await signOut(auth);
          history.push('/signin');
        }}
      >
        <p>Sair</p>
      </SignOutButton>
    </Container>
  );
};

export default DropDownMenu;
